import React from 'react';

import { Svg, type SvgProps } from './svg';

export function MoveIcon(props: SvgProps) {
  return (
    <Svg data-testid="move-icon" {...props}>
      <path
        stroke="var(--mi-text-color)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m5 9-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"
      />
    </Svg>
  );
}
